export function setStorage(key, value) {
  if (typeof localStorage.getItem("token") === "string")
    localStorage.setItem(key, value);
  else sessionStorage.setItem(key, value);
}
export function getStorage(key) {
  console.log(key)
  if (typeof localStorage.getItem("token") === "string")

    return localStorage.getItem(key);
  else return sessionStorage.getItem(key);
}
